import React from "react";

interface PropTypes {
  currentKey: string;
  children: React.ReactNode;
}

function TabContent(props: PropTypes) {
  let render = null;
  React.Children.forEach(props.children, (child: any) => {
    if (props.currentKey === child.key) {
      render = child;
    }
  });
  return render;
}

export default React.memo(TabContent);
